/* RESPONSIBLE TEAM: team-automation-foundations */
import IntercomRoute from 'embercom/routes/base/intercom-route';

export default class AppsAppOperatorResolutionBotBehaviorsRoute extends IntercomRoute {}
